import { createSlice } from '@reduxjs/toolkit';


export const serverState = createSlice({
	
	name: "serverState",

	initialState: {
		production_mode_bool: [true, false][0],
		uri: undefined
	},

	// to send data to these:
	// use useDispatch()
	// or
	// store.dispatch({type: "myName/myReducer",payload: {...}}); 
	
	reducers: {
	
		init: (state, action) => {
			if ( state.production_mode_bool ) {
				state.uri = "https://www.futurelingua.net/wb-demo/";
			} else {
				state.uri = "http://online-workbook:8888/";
			}
		},

		setServerState: (state, action) => {
			//This makes or resets a property
			
			let js = action.payload;

			let id = js.id;
			let data_js = js.data_js;

			state[id] = data_js;
		}

	}

});

export const {
	init,
	setServerState
} = serverState.actions;

// useSelector( getServerState ) subscribes to this:
// useSelector( (state) => getServerState(state, args**) ) subscribes to this:

export const getServerState = (state) => {
	return state.serverState;
}


export const getServerUri = (state) => {
	return state.serverState.uri;
}


export default serverState.reducer;